var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogout = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53369 8.50923H14",
    stroke: "#171719",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1525 6.66309L14 8.50924L12.1525 10.3554",
    stroke: "#171719",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3372 12.6538C11.5077 13.5178 10.4385 14.114 9.26719 14.3658C8.09582 14.6176 6.87586 14.5135 5.76421 14.0668C4.65257 13.6201 3.70008 12.8513 3.02927 11.8592C2.35846 10.8672 2 9.69728 2 8.5C2 7.30272 2.35846 6.13283 3.02927 5.14079C3.70008 4.14875 4.65257 3.37994 5.76421 2.93324C6.87586 2.48654 8.09582 2.38239 9.26719 2.63419C10.4385 2.88598 11.5077 3.4822 12.3372 4.34616",
    stroke: "#171719",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logout.eb8e9feb.svg";
export { ForwardRef as ReactComponent };